/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Foundationname1Inputs */

const de__field_foundationname1 = /** @type {(inputs: _Field_Foundationname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förderpartner:in`)
};

/**

* @param {_Field_Foundationname1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_foundationname1 = /** @type {((inputs?: _Field_Foundationname1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Foundationname1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_foundationname1(inputs)
});
export { _field_foundationname1 as "_field_foundationName" }